
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contato-instantaneo/perfil/[root]/[...slug]",
      function () {
        return require("private-next-pages/contato-instantaneo/perfil/[root]/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contato-instantaneo/perfil/[root]/[...slug]"])
      });
    }
  